/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureEaDepartment extends models.ServiceAccountNativeDetailsBaseForStructure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureEaDepartment");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureEaDepartment.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureEaDepartment>): ServiceAccountNativeDetailsForAzureEaDepartment {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureEaDepartment(), model);
        ServiceAccountNativeDetailsForAzureEaDepartment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureEaDepartment>): ServiceAccountNativeDetailsForAzureEaDepartment {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureEaDepartment.newInstance(<ServiceAccountNativeDetailsForAzureEaDepartment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureEaDepartment) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureEaDepartment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureEaDepartment): boolean {
        if (models.ServiceAccountNativeDetailsBaseForStructure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureEaDepartment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Department Id
     */
    department_id: string;

    /**
     * Department Name
     */
    department_name: string;

}
